<!--
 * @Author: ken yang
 * @Date: 2023-08-03 11:20:45
 * @LastEditTime: 2023-08-04 10:49:39
 * @LastEditors: ken yang
 * @Description:
 * @FilePath: /uexch_h5/src/components/widget/DiaOverlay.vue
-->
<template>
  <Column class="dia-over-lay box-border" x="c" y="s" @click="props.close()">
    <Row class="dol-body text-center" x="c" y="c" word-break>
      <img v-if="status === 'success'" :src="successIcon" class="w-40 h-40 mr-16px shrink-0" alt="">
      <span>{{ message }}</span>
    </Row>
  </Column>

</template>
<script setup>
import successIcon from '@/image/common/right.png'

const props = defineProps({
  message: {
    default: 'text'
  },
  status: {
    default: ''
  },
  close: {},
  duration: {
    default: 3000
  }
})

let closeTimer
onBeforeMount(() => {
  closeTimer = setTimeout(() => {
    props.close()
  }, props.duration)
})
onBeforeUnmount(() => clearTimeout(closeTimer))

</script>
<style lang="scss" scoped>
.dia-over-lay{
 position: fixed;
 left: 0px;
 right: 0px;
 top: 0px;
 bottom: 0px;
 padding-top: max(calc(env(safe-area-inset-top, 0px) + 24px), 128px);
 z-index:199991;
 .dol-body{
   max-width: 630px;
  background: #16151ac7;
  border-radius: 16px;
  color: #fff;
  font-size: 32px;
  padding: 30px 40px;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-all;
 }
}

</style>
